import { Component } from "@angular/core";

@Component({
	templateUrl: "./print.component.html",
})
export class PrintComponent {}
